import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-custom-info',
  templateUrl: './custom-info.component.html',
  styleUrls: ['./custom-info.component.scss']
})
export class CustomInfoComponent {
  @Input() title: string = '';
  @Input() description: string = '';
}
